import { useState, useCallback } from "react";
import {axiosInstanceV2 } from "../services/AxiosIntercepter";
import { ApiType } from "../services/ApiTags";

const useAxiosHookV2FileUpload = () => {
  const [dataResponseFileUpload, setData] = useState(null);
  const [apiCallErrorFileUpload, setApiCallError] = useState(null);
  const [showProgressBarFileUpload, setProgressBar] = useState(false);
  const fetchDataFileUpload = useCallback(
    async (
      url,
      apiType,
      method = ApiType.POST_METHOD,
      requestData,
      options = {},
      callback
    ) => {
      // show progress bar
      setProgressBar(true);

      try {
        const response = await axiosInstanceV2({
          url,
          method,
          data: requestData,
          ...options,
        });
        setData(response.data);
        if (callback) {
          callback(response.data);
        }
      } catch (error) {
        // show error
        setApiCallError(error);
      } finally {
        // hide progress bar
        setProgressBar(false);
      }
    },
    []
  );

  return { dataResponseFileUpload,apiCallErrorFileUpload, showProgressBarFileUpload, fetchDataFileUpload  };
};

export default useAxiosHookV2FileUpload;
